export enum YEAR_VIEW {
  ALL_TIME = 'all-time',
}
